var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"is-size-3"},[_vm._v("Oops! The page you are looking for is not found.")]),_c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to home!")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }